<!--
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-09-05 21:51:35
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-09-15 14:30:21
-->
<template>
  <div class="load-more-wrapper" @touchstart="touchStart" @touchend="touchEnd">
    <div class="inner">
      <slot />
      <div v-show="enableLoadMore" class="load-more">{{ loadMoreText }}</div>
      <div v-show="!enableLoadMore" class="load-end">已经到底了!</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadMore',
  props: {
    enableLoadMore: {
      type: Boolean,
      default: true
    },
    onLoadMore: {
      type: Function,
      default: undefined,
      require: false
    },
    loadMoreText: {
      type: String,
      default: '加载中...'
    }
  },
  data() {
    return {
      // loadMoreText: '~ 到底了 ~',
      startX: 0,
      startY: 0,
      isLoading: false
    }
  },
  methods: {
    touchStart(e) {
      this.startY = e.targetTouches[0].pageY
      this.startX = e.targetTouches[0].pageX
    },
    scrollToEnd(e) {
      const scrollHeight = this.$el.scrollHeight
      const clientHeight = this.$el.clientHeight
      const scrollTop = this.$el.scrollTop

      if (scrollTop + clientHeight >= scrollHeight || this.enableLoadMore) {
        this.doLoadMore()
      }
    },
    touchEnd(e) {
      if (this.isLoading) {
        return
      }

      const endX = e.changedTouches[0].pageX
      const endY = e.changedTouches[0].pageY
      const dy = this.startY - endY
      const dx = endX - this.startX
      if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
        return
      }
      if (endY < this.startY) {
        this.scrollToEnd(e)
      }
    },
    doLoadMore() {
      this.isLoading = true
      this.onLoadMore(this.loadDone)
    },
    loadDone() {
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.load-more-wrapper {
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    transition-duration: 300ms;
    .load-more, .load-end {
        color: #aea699;
        font-size: .26rem;
        margin: .3rem 0;
        text-align: center;
    }
}

</style>
